import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/state';
import { SidenavService } from '../../services/sidenav/sidenav.service';
import { LayoutService } from '../../services/layout/layout.service';
import * as CoreActions from '../../store/actions';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  menuItems$ = this.sidenavService.getMenuItems();
  opened$ = this.layout.sidenavOpened$;

  constructor(
    private sidenavService: SidenavService,
    private layout: LayoutService,
    private store: Store<IAppState>
  ) {}

  signOut(): void {
    this.store.dispatch(CoreActions.signOut());
  }
}
